export const setREQUESTOBJECT = "setREQUESTOBJECT";

export const resetREQUESTOBJECT = "resetREQUESTOBJECT";
